import { Box, BoxProps } from '@modusign/design-system';

interface WindowModalFooterProps extends BoxProps<'div'> {}

const defaultProps = {
  p: 4,
};

function WindowModalFooter(props: WindowModalFooterProps) {
  return (
    <Box
      backgroundColor="lightGray50"
      borderBottomLeftRadius="3px"
      borderBottomRightRadius="3px"
      borderTop="1px solid"
      borderTopColor="lightGray300"
      height="65px"
      width="100%"
      {...props}
    />
  );
}

WindowModalFooter.defaultProps = defaultProps;

export default WindowModalFooter;
